<template>
    <div>
        <!-- Clonar Modal -->
        <div class="modal fade" id="clonarSoliciAutorizModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Clonar Solicitação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="solic">
                        <div class="alert alert-info">
                            <div class="lead">
                                {{ solic.paciente ? solic.paciente.st_nome : solic.cadastro_temporario.st_nome }}
                            </div>
                            <div>
                                {{ solic.procedimento.search }}
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Data da Solicitação"
                                    type="date"
                                    v-model="solic.dt_solicitacao"  />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar">Clonar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';


export default {
    data() {
        return { 
            solic: null, 
        }
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    methods: { 
        abrir (solic) { 
            this.solic = _.cloneDeep(solic);

            $('#clonarSoliciAutorizModal').modal('show');
        },

        atualizar () { 
            if ( !confirm('Confirmar clonar essa solicitação para da data informada?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'clonar',
                dados: { 
                    id_solicitacao_autorizacao: this.solic.id_solicitacao_autorizacao,
                    dt_solicitacao: this.solic.dt_solicitacao,
                },
                modal: 'clonarSoliciAutorizModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

    }
}
</script>
